'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Style = require('../core/Style');

var _PageConstants = require('./PageConstants');

var _UIAbstractPageGridContent = require('./UIAbstractPageGridContent');

var _UIAbstractPageGridContent2 = _interopRequireDefault(_UIAbstractPageGridContent);

var _UIAbstractPageSection = require('./UIAbstractPageSection');

var _UIAbstractPageSection2 = _interopRequireDefault(_UIAbstractPageSection);

var _UIPage = require('./UIPage');

var _UIPage2 = _interopRequireDefault(_UIPage);

var _UIHeader = require('../layout/UIHeader');

var _UIHeader2 = _interopRequireDefault(_UIHeader);

var _customRenderer = require('../utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

var _deprecated = require('../utils/propTypes/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function mainWrapperBackgroundColor(color) {
  return {
    backgroundColor: color
  };
}

function renderHeader(headerComponent, headerUse, alertComponent, title) {
  var headerOptions = {
    title: title,
    use: headerUse
  };

  if (alertComponent) {
    headerOptions = _extends({
      alert: alertComponent
    }, headerOptions);
  }

  return CustomRenderer.render(headerComponent, headerOptions);
}

function getBodyClassNames(bodyClassName, pageLayout) {
  return (0, _reactUtils.classNames)('space-sword', bodyClassName, {
    'space-sword--max-width': pageLayout === 'max-width'
  });
}

function UIAbstractPageTemplate(_ref) {
  var alertComponent = _ref.alertComponent,
      bodyClassName = _ref.bodyClassName,
      children = _ref.children,
      className = _ref.className,
      contentAreaFlush = _ref.contentAreaFlush,
      headerComponent = _ref.headerComponent,
      horizontalDivider = _ref.horizontalDivider,
      narrowLayout = _ref.narrowLayout,
      mainSectionBackgroundColor = _ref.mainSectionBackgroundColor,
      mainSectionComponent = _ref.mainSectionComponent,
      mainSectionStyle = _ref.mainSectionStyle,
      moveSidebarToBottom = _ref.moveSidebarToBottom,
      pageBackgroundColor = _ref.pageBackgroundColor,
      pageLayout = _ref.pageLayout,
      pageMaxWidth = _ref.pageMaxWidth,
      pageStyle = _ref.pageStyle,
      sidebarComponent = _ref.sidebarComponent,
      tabs = _ref.tabs,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ['alertComponent', 'bodyClassName', 'children', 'className', 'contentAreaFlush', 'headerComponent', 'horizontalDivider', 'narrowLayout', 'mainSectionBackgroundColor', 'mainSectionComponent', 'mainSectionStyle', 'moveSidebarToBottom', 'pageBackgroundColor', 'pageLayout', 'pageMaxWidth', 'pageStyle', 'sidebarComponent', 'tabs', 'title']);

  var headerUse = tabs ? 'condensed' : undefined;

  var headerWrapperClassNames = (0, _reactUtils.classNames)('private-template__section--header');

  var mainWrapperClassNames = (0, _reactUtils.classNames)('private-template__section--stretch', {
    'private-template__section--divided': horizontalDivider,
    'private-template--narrow': narrowLayout
  });

  var pageClassName = (0, _reactUtils.classNames)('private-template', _PageConstants.LAYOUT_CLASSES[pageLayout], className);

  var sectionClassNames = (0, _reactUtils.classNames)({
    'private-template__section--spaced-vertical': !contentAreaFlush,
    'private-template__section--flush': contentAreaFlush
  });

  var templateBackgroundColor = function templateBackgroundColor(color) {
    return {
      backgroundColor: color
    };
  };

  var templateMaxWidth = function templateMaxWidth(width) {
    if (!width) return null;

    return {
      maxWidth: (0, _Style.remCalc)(width)
    };
  };

  return _react2.default.createElement(
    'div',
    { className: 'private-ie11-flex-wrapper' },
    _react2.default.createElement(
      _UIPage2.default,
      _extends({}, rest, {
        bodyClassName: getBodyClassNames(bodyClassName, pageLayout),
        className: pageClassName,
        style: _extends({}, templateBackgroundColor(pageBackgroundColor), pageStyle)
      }),
      _react2.default.createElement(
        _UIAbstractPageSection2.default,
        {
          className: headerWrapperClassNames,
          style: _extends({}, templateMaxWidth(pageMaxWidth))
        },
        renderHeader(headerComponent, headerUse, alertComponent, title),
        tabs
      ),
      _react2.default.createElement(
        'div',
        {
          className: mainWrapperClassNames,
          style: _extends({}, mainWrapperBackgroundColor(mainSectionBackgroundColor), mainSectionStyle)
        },
        _react2.default.createElement(
          _UIAbstractPageSection2.default,
          {
            className: sectionClassNames,
            style: _extends({}, templateMaxWidth(pageMaxWidth))
          },
          CustomRenderer.render(mainSectionComponent, {
            children: children,
            mainSectionBackgroundColor: mainSectionBackgroundColor,
            mainSectionStyle: mainSectionStyle,
            moveSidebarToBottom: moveSidebarToBottom,
            sidebarComponent: sidebarComponent
          })
        )
      )
    )
  );
}

var alertDeprecationMsg = {
  key: 'UIAbstractPageTemplate: alert deprecated',
  message: 'Page template: passing both a custom headerComponent and alertComponent can lead ' + 'to unexpected results. Include the alert(s) directly in the headerComponent content ' + 'for more predictable output.\n' + 'For more details, see: https://git.hubteam.com/HubSpot/UIComponents/issues/3934'
};

var getAlertDeprecation = function getAlertDeprecation(name, value) {
  var allProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var header = allProps.headerComponent;
  var hasSafeHeader = value == null || header == null || typeof header === 'function' || _react2.default.isValidElement(header) && header.type === _UIHeader2.default;

  return !hasSafeHeader ? alertDeprecationMsg : null;
};

UIAbstractPageTemplate.propTypes = {
  alertComponent: (0, _deprecated2.default)(_react.PropTypes.node, getAlertDeprecation),
  bodyClassName: _react.PropTypes.string,
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  contentAreaFlush: _react.PropTypes.bool.isRequired,
  horizontalDivider: _react.PropTypes.bool.isRequired,
  headerComponent: CustomRenderer.propType,
  mainSectionBackgroundColor: _react.PropTypes.string,
  mainSectionComponent: CustomRenderer.propType,
  mainSectionStyle: _react.PropTypes.object,
  moveSidebarToBottom: _react.PropTypes.bool,
  narrowLayout: _react.PropTypes.bool.isRequired,
  pageBackgroundColor: _react.PropTypes.string,
  pageLayout: _react.PropTypes.oneOf(Object.keys(_PageConstants.LAYOUT_CLASSES)),
  pageMaxWidth: _react.PropTypes.number,
  pageStyle: _react.PropTypes.object,
  sidebarComponent: CustomRenderer.propType,
  tabs: _react.PropTypes.node,
  title: _react.PropTypes.node
};

UIAbstractPageTemplate.defaultProps = {
  contentAreaFlush: false,
  headerComponent: _UIHeader2.default,
  horizontalDivider: false,
  mainSectionComponent: _UIAbstractPageGridContent2.default,
  moveSidebarToBottom: false,
  narrowLayout: false,
  pageLayout: 'max-width'
};

UIAbstractPageTemplate.displayName = 'UIAbstractPageTemplate';

exports.default = UIAbstractPageTemplate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/page/UIAbstractPageTemplate.js
// module id = 364
// module chunks = 0